export const existingIcons = [
    '/images/themes/icons/gamably.png',
    '/images/themes/icons/medieval.png',
    '/images/themes/icons/pirates.png',
    '/images/themes/icons/space.png',
    '/images/themes/magic_icon.jpg',
    '/images/themes/icons/zombie.png',
]

export const existingHeaders = [
    '/images/themes/logos/gamably.png',
    '/images/themes/logos/zombie.png',
    '/images/themes/2025/magic_head.png',
    '/images/themes/logos/space.png',
    '/images/themes/logos/professional.png',
    '/images/themes/logos/pirates.png',
    '/images/themes/logos/medieval.png',
]

export const existingBgs = [
    {
        'path':'/images/themes/2025/zombie_bg.jpg',
        'button': '#29392f',
    },
    {
        'path': '/images/themes/2025/space_bg.jpg',
        'button': '#035e83',
    },
    {
        'path': '/images/themes/2025/pirate_bg.jpg',
        'button': '#98302c',
    },
    {
        'path': '/images/themes/2025/magic_bg.jpg',
        'button': '#0092ad',
    },
    // {
    //     'path': '/images/themes/bg/golf.jpg',
    //     'button': '#FE0000',
    // },
    // {
    //     'path': '/images/themes/bg/desert.jpg',
    //     'button': '#CC0001',
    // },
    // {
    //     'path': '/images/themes/bg/castle.jpg',
    //     'button': '#EF6E4B',
    // },
    // {
    //     'path': '/images/themes/bg/80s.jpg',
    //     'button': '#FF2FFF',
    // },
    {
        'path': '/images/themes/2025/roman_bg.jpg',
        'button': '#6b4820',
    },
    // {
    //     'path': '/images/themes/bg/jungle2.jpg',
    //     'button': '#705216',
    // },
    {
        'path': '/images/themes/2025/medieval_bg.jpg',
        'button': '#be6a5f',
    },
    {
        'path': '/images/themes/2025/80s_bg.jpg',
        'button': '#b730d3',
    }
]

export const existingGradients = [
    {hexBottom: '#d1cede', hexTop: '#e9e7f4', button: '#674EA7'},
    {hexBottom: '#2193b0', hexTop: '#6dd5ed', button: '#0E5769'},
    {hexBottom: '#203A43', hexTop: '#2C5364', button: '#508CA5'},
    {hexBottom: '#c471ed', hexTop: '#f64f59', button: '#F64F59'},
    {hexBottom: '#4A00E0', hexTop: '#8E2DE2', button: '#ac6ae5'},
    {hexBottom: '#c8e0e3', hexTop: '#E3F5F7', button: '#f27353'},
    
    {
        "hexBottom": "#3a6073",
        "hexTop": "#3a7bd5",
        "button": "#1e3c72"
    },
    {
        "hexBottom": "#ff7e5f",
        "hexTop": "#feb47b",
        "button": "#800000"
    },
    {
        "hexBottom": "#004ff9",
        "hexTop": "#fff94c",
        "button": "#000033"
    },
    {
        "hexBottom": "#8e2de2",
        "hexTop": "#4a00e0",
        "button": "#330066"
    },
    {
        "hexBottom": "#f857a6",
        "hexTop": "#ff5858",
        "button": "#7a0018"
    },
    {
        "hexBottom": "#e65c00",
        "hexTop": "#f9d423",
        "button": "#4d3300"
    },
    {
        "hexBottom": "#c33764",
        "hexTop": "#1d2671",
        "button": "#0d113f"
    },
    {
        "hexBottom": "#ffc3a0",
        "hexTop": "#ffafbd",
        "button": "#3f000f"
    },
    {
        "hexBottom": "#00c6ff",
        "hexTop": "#0072ff",
        "button": "#003366"
    },
    {
        "hexBottom": "#dce35b",
        "hexTop": "#45b649",
        "button": "#18451a"
    },
    {
        "hexBottom": "#6a3093",
        "hexTop": "#a044ff",
        "button": "#400080"
    },
    {
        "hexBottom": "#a7a6cb",
        "hexTop": "#8989ba",
        "button": "#1f1e33"
    },
    {
        "hexBottom": "#1a2a6c",
        "hexTop": "#b21f1f",
        "button": "#660000"
    },
    {
        "hexBottom": "#fc00ff",
        "hexTop": "#00dbde",
        "button": "#551a8b"
    },
    {
        "hexBottom": "#f7bb97",
        "hexTop": "#dd5e89",
        "button": "#660022"
    },
    {
        "hexBottom": "#5433ff",
        "hexTop": "#20bdff",
        "button": "#1a004d"
    },
    {
        "hexBottom": "#4b6cb7",
        "hexTop": "#182848",
        "button": "#0a1020"
    },
    {
        "hexBottom": "#36d1dc",
        "hexTop": "#5b86e5",
        "button": "#1e306e"
    },
    {
        "hexBottom": "#009245",
        "hexTop": "#fceca3",
        "button": "#003300"
    },
    {
        "hexBottom": "#e9d460",
        "hexTop": "#ff8888",
        "button": "#440000"
    },

    {
        "hexBottom": "#16222a",
        "hexTop": "#3a6073",
        "button": "#0d1115"
    },
    {
        "hexBottom": "#2c3e50",
        "hexTop": "#3498db",
        "button": "#1a252f"
    },
    {
        "hexBottom": "#351c75",
        "hexTop": "#5b2c6f",
        "button": "#1f0f41"
    },
    {
        "hexBottom": "#0f2027",
        "hexTop": "#203a43",
        "button": "#050a0c"
    },
    {
        "hexBottom": "#596164",
        "hexTop": "#869398",
        "button": "#2b3031"
    },
    {
        "hexBottom": "#4a0000",
        "hexTop": "#667292",
        "button": "#220000"
    },
    {
        "hexBottom": "#1a2a6c",
        "hexTop": "#3d5a7d",
        "button": "#0c1537"
    },
    {
        "hexBottom": "#130f40",
        "hexTop": "#4834d4",
        "button": "#0c092c"
    },
    {
        "hexBottom": "#1e3c72",
        "hexTop": "#2a5298",
        "button": "#0f1e39"
    },
    {
        "hexBottom": "#000000",
        "hexTop": "#434343",
        "button": "#111111"
    },
    {
        "hexBottom": "#3e1e68",
        "hexTop": "#9d375d",
        "button": "#1d0f34"
    },
    {
        "hexBottom": "#243b55",
        "hexTop": "#141e30",
        "button": "#0a0f18"
    },
    {
        "hexBottom": "#0f0c29",
        "hexTop": "#302b63",
        "button": "#070614"
    },
    {
        "hexBottom": "#2b5876",
        "hexTop": "#4e4376",
        "button": "#152c3b"
    },
    {
        "hexBottom": "#00467f",
        "hexTop": "#a5cc82",
        "button": "#002340"
    },
    {
        "hexBottom": "#4b6cb7",
        "hexTop": "#182848",
        "button": "#0c1424"
    },
    {
        "hexBottom": "#1c92d2",
        "hexTop": "#f1f2b5",
        "button": "#0e4969"
    },
    {
        "hexBottom": "#0f3446",
        "hexTop": "#0f4646",
        "button": "#071a23"
    },
    {
        "hexBottom": "#440000",
        "hexTop": "#990000",
        "button": "#220000"
    },
    {
        "hexBottom": "#314755",
        "hexTop": "#26a0da",
        "button": "#1b272f"
    }
]